export default "__VITE_ASSET__e57f8122__"